module.exports = __webpack_public_path__ + "img/document_active.904b3971.svg";